import { render } from "./SettingsSubCategories.vue?vue&type=template&id=4904c53c"
import script from "./SettingsSubCategories.vue?vue&type=script&lang=js"
export * from "./SettingsSubCategories.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__